import React, { useState, useEffect } from 'react';
import { AvatarGenerationContentProps, AVATAR_STYLES, AvatarStyleType } from './types';
import { Textarea } from '@/components/ui/textarea';
import AvatarStyleSelector from './AvatarStyleSelector';

const AvatarGenerationContent: React.FC<AvatarGenerationContentProps> = ({ 
  aspectRatio = 1,
  setDescription,
  setStyle
}) => {
  const [description, setLocalDescription] = useState('');
  const [selectedStyle, setSelectedStyle] = useState<AvatarStyleType>('photo');
  
  // Update parent component whenever values change
  useEffect(() => {
    if (setDescription) {
      setDescription(description);
    }
    if (setStyle) {
      setStyle(selectedStyle);
    }
  }, [description, selectedStyle, setDescription, setStyle]);
  
  const handleDescriptionChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newDescription = e.target.value;
    setLocalDescription(newDescription);
  };
  
  const handleStyleChange = (style: AvatarStyleType) => {
    setSelectedStyle(style);
  };

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Textarea
          id="description"
          placeholder="Describe your avatar (e.g., professional woman with short brown hair and glasses, business attire)"
          value={description}
          onChange={handleDescriptionChange}
          className="min-h-[100px] resize-none"
        />
      </div>

      <div className="space-y-2">
        <AvatarStyleSelector 
          selectedStyle={selectedStyle} 
          onSelectStyle={handleStyleChange}
          styles={AVATAR_STYLES}
        />
      </div>
    </div>
  );
};

export default AvatarGenerationContent;
